import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DoneAllSharpIcon from "@mui/icons-material/DoneAllSharp";
import { gsap } from "gsap";
import { useLocation } from "react-router-dom";

import "../../../../assets/css/chat/chattingInfo.css";
import Avatar from "@mui/material/Avatar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import bg_effect from "../../../../assets/media/chat-app-bg.svg";

import { responsiveUI } from "../../../../store/slices/chatUi";
import "../../../../assets/css/chat/chattingInfo.css";

const ChattingInfo = () => {
  const [channelArray, setChannelArray] = useState([]);
  let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const dispatch = useDispatch();
  const selectedRoom = useSelector((state) => state.chat.selectedRoom);
  const { pathname } = useLocation();
  const chatSocket = useSelector((state) => state.chat.socket);
  const chat_info_parent = useRef();
  const userDetails = useSelector((state) => state.basicInfo.userDetails);

  const hide_user_details = () => {
    dispatch(responsiveUI(false));
  };

  // animation
  useEffect(() => {
    const roomIdFromPath = pathname.split("/");
    if (!channelArray.includes(roomIdFromPath[roomIdFromPath.length - 1])) {
      let chat_info_tl_1 = gsap.timeline();

      let anim_qury = gsap.utils.selector(chat_info_parent);
      let anim_qury_2 = anim_qury(".chatting-info-process-box");
      let anim_qury_3 = anim_qury(".chat-info-last-orders-card");

      chat_info_tl_1.progress();

      chat_info_tl_1.from(anim_qury(".chattingInfo-img"), {
        y: -150,
        opacity: 0,
      });

      chat_info_tl_1.to(anim_qury(".chattingInfo-img"), { y: -0, opacity: 1 });

      for (let i = 0; anim_qury_2.length > i; i++) {
        chat_info_tl_1
          .from(anim_qury_2[i], { y: -50, opacity: 0 })
          .to(anim_qury_2[i], { y: 0, opacity: 1 });
      }

      for (let i = 0; anim_qury_3.length > i; i++) {
        chat_info_tl_1
          .from(anim_qury_3[i], { y: -50, opacity: 0 })
          .to(anim_qury_3[i], { y: 0, opacity: 1 });
      }

      chat_info_tl_1
        .from(anim_qury(".chat-info-bg-img"), { y: -250 })
        .to(anim_qury(".chat-info-bg-img"), { y: 0 });

      chat_info_tl_1.duration(1);

      setChannelArray([
        ...channelArray,
        roomIdFromPath[roomIdFromPath.length - 1],
      ]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat_info_parent, pathname]);

  const blockUnblockUser = () => {
    let command = "block";
    if (selectedRoom?.blocked_by_list?.includes(userDetails.id)) {
      command = "unblock";
    }
    chatSocket?.send(
      JSON.stringify({
        command: command,
        room_id: selectedRoom.channel_id,
      })
    );
  };

  return (
    <>
      {viewportWidth <= 1260 && (
        <div className="chatInfo-overflow" onClick={hide_user_details}></div>
      )}

      <div className="chattingInfo" ref={chat_info_parent}>
        <div className="chat-info-bg-img">
          <img src={bg_effect} alt="" />
        </div>
        {viewportWidth <= 1400 && (
          <Button onClick={hide_user_details} className="back-from-user-info">
            <ArrowBackIcon />
          </Button>
        )}

        <div className="chattingInfo-img">
          <Avatar
            className="chat-info-avatar-img"
            alt="Remy Sharp"
            src={
              selectedRoom.partner_info?.profile_image &&
              selectedRoom.partner_info.profile_image
            }
          />
        </div>

        <h1 className="chatting-info-avatar-name">
          {selectedRoom.partner_info?.full_name}
        </h1>

        <p className="chatting-info-user-list justify-content-center">
          <span>Tracking Id :</span>
          <span>{selectedRoom?.order_details?.tracking_id}</span>
        </p>

        <Button onClick={blockUnblockUser} className="mt-2 mb-2 d-flex m-auto">
          {selectedRoom?.blocked_by_list?.includes(userDetails.id)
            ? "Unblock"
            : "Block"}
        </Button>

        <ChatInfoTImeLine compeleted={selectedRoom?.order_details?.status} />

        {/* <LastFiveOrders /> */}
      </div>
    </>
  );
};

export default ChattingInfo;

const ChatInfoTImeLine = ({ compeleted }) => {
  const status_list = [
    "Created",
    "Picked Up",
    "In Progress",
    "Delivery Requested",
    "Finished",
  ];

  return (
    <div className="chatting-info-process-timeline">
      {status_list.map((item, i) => (
        <div
          className="chatting-info-process-box"
          key={i}
          compeleted-status={compeleted > i ? "true" : "false"}
        >
          <div className="chatting-info-process-box-icon">
            <DoneAllSharpIcon />
          </div>
          <div className="chatting-info-process-name">{item}</div>
        </div>
      ))}
    </div>
  );
};

// this funtion is committed
const LastFiveOrders = () => (
  <div className="chat-info-last-orders">
    <h1> Last 5 Order List </h1>

    <a href="#/">
      <div className="chat-info-last-orders-card">
        <p className="chatting-info-user-list">
          <span>Tracking Id :</span>
          <span>49082374899798732</span>
        </p>
        <div className="chat-info-last-orders-img-info">
          <Avatar
            className="chat-info-last-orders-user-img"
            alt="Remy Sharp"
            src="https://media.istockphoto.com/photos/handsome-young-businessman-picture-id997770954?b=1&k=20&m=997770954&s=170667a&w=0&h=vK063QTVtGVtQ_JOXxocxJdSwY18_rVoMTut7QXhz3c="
          />

          <div>
            <p className="chatting-info-user-list">
              <span>Name :</span>
              <span>Benjamin L. Mayfield</span>
            </p>
            <p className="chatting-info-user-list">
              <span>Current Status :</span>
              <span>In Progress</span>
            </p>
            <p className="chatting-info-user-list">
              <span>Started At :</span>
              <span>02-07-2020</span>
            </p>
          </div>
        </div>
      </div>
    </a>
    <a href="#/">
      <div className="chat-info-last-orders-card">
        <p className="chatting-info-user-list">
          <span>Tracking Id :</span>
          <span>49082374899798732</span>
        </p>
        <div className="chat-info-last-orders-img-info">
          <Avatar
            className="chat-info-last-orders-user-img"
            alt="Remy Sharp"
            src="https://media.istockphoto.com/photos/handsome-young-businessman-picture-id997770954?b=1&k=20&m=997770954&s=170667a&w=0&h=vK063QTVtGVtQ_JOXxocxJdSwY18_rVoMTut7QXhz3c="
          />

          <div>
            <p className="chatting-info-user-list">
              <span>Name :</span>
              <span>Benjamin L. Mayfield</span>
            </p>
            <p className="chatting-info-user-list">
              <span>Current Status :</span>
              <span>In Progress</span>
            </p>
            <p className="chatting-info-user-list">
              <span>Started At :</span>
              <span>02-07-2020</span>
            </p>
          </div>
        </div>
      </div>
    </a>
    <a href="#/">
      <div className="chat-info-last-orders-card">
        <p className="chatting-info-user-list">
          <span>Tracking Id :</span>
          <span>49082374899798732</span>
        </p>
        <div className="chat-info-last-orders-img-info">
          <Avatar
            className="chat-info-last-orders-user-img"
            alt="Remy Sharp"
            src="https://media.istockphoto.com/photos/handsome-young-businessman-picture-id997770954?b=1&k=20&m=997770954&s=170667a&w=0&h=vK063QTVtGVtQ_JOXxocxJdSwY18_rVoMTut7QXhz3c="
          />

          <div>
            <p className="chatting-info-user-list">
              <span>Name :</span>
              <span>Benjamin L. Mayfield</span>
            </p>
            <p className="chatting-info-user-list">
              <span>Current Status :</span>
              <span>In Progress</span>
            </p>
            <p className="chatting-info-user-list">
              <span>Started At :</span>
              <span>02-07-2020</span>
            </p>
          </div>
        </div>
      </div>
    </a>
  </div>
);
